import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { CacheService } from '@core/services/cache/cache.service'
import { UserService } from '@participant/services/user.service'

export const isUserAuthenticatedGuard: CanActivateFn = async () => {
  const userService = inject(UserService)
  const cacheService = inject(CacheService)
  const router = inject(Router)

  const user = await userService.getUser()

  if (userService.isLoggedIn()) {
    await cacheService.init(user)
    return true
  }

  return router.navigateByUrl('/login')
}
